export const EAP_SETTINGS_IMPORT_DELIMITERS = {
    COMMA: 'comma',
    SEMICOLON: 'semicolon',
    TAB: 'tab',
} as const;

export const EAP_SETTINGS_IMPORT_COLUMN_HEADERS = {
    WITH_HEADERS: 'withHeaders',
    WITHOUT_HEADERS: 'withoutHeaders',
} as const;

export type EapSettingsImportDelimiter =
    (typeof EAP_SETTINGS_IMPORT_DELIMITERS)[keyof typeof EAP_SETTINGS_IMPORT_DELIMITERS];

export type EapSettingsImportColumnHeaders =
    (typeof EAP_SETTINGS_IMPORT_COLUMN_HEADERS)[keyof typeof EAP_SETTINGS_IMPORT_COLUMN_HEADERS];

export const DELIMITER_CHARS: Record<EapSettingsImportDelimiter, string> = {
    [EAP_SETTINGS_IMPORT_DELIMITERS.COMMA]: ',',
    [EAP_SETTINGS_IMPORT_DELIMITERS.SEMICOLON]: ';',
    [EAP_SETTINGS_IMPORT_DELIMITERS.TAB]: '\t',
};

export interface EapSettingsImportFlowData {
    filename: string;
    fileContent: string;
    delimiter: EapSettingsImportDelimiter;
    columnHeaders: EapSettingsImportColumnHeaders;
    pemFilenames?: string[];
}
